import { render, staticRenderFns } from "./InvoiceIncomeTable.vue?vue&type=template&id=e5545d96&scoped=true&"
import script from "./InvoiceIncomeTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceIncomeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5545d96",
  null
  
)

export default component.exports